module.exports = __webpack_public_path__ + "static/media/girls_drawing.6f783808.png";